exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.disabled[data-v-3d822b8c] .el-upload--picture-card{\n        display: none;\n}\n.avatar[data-v-3d822b8c] {\n\t\theight: 100px;\n\t\tdisplay: block;\n}\n\n\n", ""]);

// exports
